<div class="searchBarRoom">
  <ng-container *ngIf="isNotHotelPackageView; else whitInput">
    <ng-container *ngTemplateOutlet="guestsAndRooms"></ng-container>
  </ng-container>
</div>

<ng-template #whitInput>
  <app-search-input-bar
    [id]="'search-bar-room'"
    [searchType]="searchType"
    [isHome]="isHome"
    [label]="label"
    [icon]="icon" 
    [value]="control.value"
    [placeholder]="placeholder"
    [isMobile]="isMobile"
    [isPackageHotelStep]="isHotelPackageView"
    (inputFocus)="toggle(true)">
  </app-search-input-bar>
  
  <ng-container *ngIf="isMobile; else desktop">
    <app-drop-down-view
      [defaultState]="show"
      [title]="'SEARCH_MODULE.ROOMS.ROOMS' | transloco"
      [showFooter]="true"
      [autoHeight]="isHotelDetail"
      [closeJustInCase]="validateChildrenAges()"
      (closeEvent)="toggle()">
      <div class="searchBarRoom__view-content" content>
        <ng-container *ngTemplateOutlet="guestsAndRooms"></ng-container>
      </div>
      <ng-container footer *ngTemplateOutlet="guestsAndRoomsFooter"></ng-container>
    </app-drop-down-view>
  </ng-container>

  <ng-template #desktop>
    <ng-container *ngIf="show">
      <div class="searchBarRoom__bg" *ngIf="!isNotHotelPackageView" (click)="toggle()"></div>
      <div class="searchBarRoom__selection">
        <div class="searchBarRoom__selection-cont" [ngStyle]="swipeScrollStyles">
          <p class="searchBarRoom__selection-title">{{ 'SEARCH_MODULE.ROOMS.ROOMS' | transloco }}</p>
          <ng-container *ngTemplateOutlet="guestsAndRooms"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="guestsAndRoomsFooter"></ng-container>
      </div>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #guestsAndRooms>
  <div class="searchBarRoom__selection-info" #searchRoomContainer>
    <ng-container *ngFor="let room of hotelRooms; let i = index;">
      <div class="searchBarRoom__selection-card" [id]="componentIdentifier| uniqueId :i">
        <div class="searchBarRoom__selection-roomCount">
          <app-ds-typography
            [tag]="'p'"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.SemiBold"
            [text]="('SEARCH_MODULE.ROOMS.ROOM' | transloco) + ' ' + roomNumber(i)">
          </app-ds-typography>
        </div>
        <div class="searchBarRoom__selection-closeRoom" [id]="'close-room-item-'| uniqueId :i " *ngIf="canRemove(i)">
          <app-ds-button-link
            [type]="buttonLinkType"
            [fontSize]="addOrRemoveRoomLabelSize"
            [icon]="minusCircleOutline"
            [iconSize]="16"
            [label]="'SEARCH_MODULE.ROOMS.DELETE' | transloco"
            (clickEvent)="removeRoom.emit(room.id)">
          </app-ds-button-link>
        </div>
        <div class="searchBarRoom__selection-roomOptions">
          <div class="searchBarRoom__selection-roomOptions-name">
            <app-ds-typography
              [tag]="'p'"
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="'SEARCH_MODULE.ROOMS.ADULTS' | transloco">
            </app-ds-typography>
          </div>
          <app-search-bar-operator
            [searchBy]="searchBy"
            [selector]="componentIdentifier| uniqueId :i :'-'"
            [type]="passengerType.ADULTS"
            [initialQuantity]="room[adults]"
            [totalPassengers]="roomTotalPassengers(room)"
            [allTotalPassengers]="totalPassengers()"
            [maxPassengers]="maxGuestPerRoom"
            (quantityEmmiter)="setRoomQuantity($event, passengerType.ADULTS, i)">
          </app-search-bar-operator>
        </div>
        <div class="searchBarRoom__selection-roomOptions">
          <div class="searchBarRoom__selection-roomOptions-name">
            <app-ds-typography
              [tag]="'p'"
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="'SEARCH_MODULE.ROOMS.CHILDREN' | transloco">
            </app-ds-typography>
            <app-ds-typography
              [size]="fontSize.XXXS"
              [color]="fontColor.Secondary"
              [text]="'SEARCH_MODULE.ROOMS.CHILDREN_DESCRIPTION' | transloco">
            </app-ds-typography>
          </div>
          <app-search-bar-operator
            [searchBy]="searchBy"
            [selector]="componentIdentifier| uniqueId :i :'-'"
            [type]="passengerType.CHILDREN"
            [initialQuantity]="room[children]"
            [totalPassengers]="roomTotalPassengers(room)"
            [allTotalPassengers]="totalPassengers()"
            [maxPassengers]="maxGuestPerRoom"
            (quantityEmmiter)="setRoomQuantity($event, passengerType.CHILDREN, i)">
          </app-search-bar-operator>
        </div>
        <div class="search-bar-room-child-ages" *ngIf="!!room[children]">
          <app-search-bar-child-ages 
            (emitAgeSelection)="setChildAges($event, i)"
            [idSelector] ="componentIdentifierChildAges| uniqueId :i"
            [childrenQuantity]="room[children]"
            [isMobile]="isMobile"
            [childrenAges]="room.childrenAges">
          </app-search-bar-child-ages>
        </div>
      </div>
      <div class="searchBarRoom__selection-card-divider">
        <app-ds-divider></app-ds-divider>
      </div>
    </ng-container>
    <ng-container *ngIf="isMobile">
      <div class="searchBarRoom__selection-addNewRoom searchBarRoom__selection-addNewRoom--view-content">
        <ng-container *ngTemplateOutlet="addRoomBtn"></ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #guestsAndRoomsFooter>
  <div class="searchBarRoom__selection-actionButton">
    <ng-container *ngIf="!isMobile">
      <div class="searchBarRoom__selection-addNewRoom">
        <ng-container *ngTemplateOutlet="addRoomBtn"></ng-container>
      </div>
    </ng-container>
    <div class="searchBarRoom__selection-searchButton" id="search-bar-room-apply">
      <ng-container *ngTemplateOutlet="buttonCont"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #buttonCont>
  <app-ds-button
    [labels]="{ ButtonLabel: 'SEARCH_MODULE.ROOMS.APPLY' | transloco }"
    (clickEvent)="applyRooms()">
  </app-ds-button>
</ng-template>

<ng-template #addRoomBtn>
  <app-ds-button-link
    [type]="buttonLinkType"
    [fontSize]="addOrRemoveRoomLabelSize"
    [icon]="addCircleOutline"
    [isDisabled]="!showAddRoom()"
    [iconSize]="16"
    [label]="'SEARCH_MODULE.ROOMS.ADD' | transloco"
    (clickEvent)="addRoom()">
  </app-ds-button-link>
</ng-template>
